import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from '../../services/localization/localization.service';

@Pipe({
  name: 'thousandDecimalFormat',
  pure: false
})
export class ThousandDecimalFormat implements PipeTransform {
    constructor(private _localizationService: LocalizationService) {
    }

    transform(
        value: any,
        neutral = false,
    ): string {
        if (value != null) {
            let formattedValue = value.toString();
            let language = window.navigator.language;
            let intergerPart;
            let decimalPart;
            if (language.includes('en-us')) {
                intergerPart = formattedValue.split('.')[0];
                decimalPart = formattedValue.split('.')[1];
                intergerPart = intergerPart.replace(/\,/g, "");
            } else if (language.includes('es-ar')) {
                intergerPart = formattedValue.split(',')[0];
                decimalPart = formattedValue.split(',')[1];
                intergerPart = intergerPart.replace(/\./g, "");
            }
            // Remover los separadores de miles actuales y reemplazar el separador decimal
            let result = "";
            let count = 0;
            
            for (let i = intergerPart.length - 1; i >= 0; i--) {
                const digit = intergerPart[i];
                result = digit + result; // Agregar el dígito actual al inicio del resultado
                count++;

                // Si hemos alcanzado un múltiplo de 3 dígitos (excepto al inicio del número), agregar el separador de miles
                if (count % 3 === 0 && i > 0) {
                    result = this._localizationService.localeData.currency.thousandSeparator + result;
                }
            }
            formattedValue = result + this._localizationService.localeData.currency.decimalSeparator + decimalPart;
            
            let rta = formattedValue;
            
            return rta;

        } else {
            return '';
        }
    }
}
